import { useMemo } from "react"

import {
  useGetGitHubIssuesSettings,
  useGetTicketingSystems
} from "@/api/useIntegrations"
import { getAllowedTicketingSystems } from "@/domain/ticketing"

import type { TicketingSystem } from "@/domain/ticketing"

const NO_SYSTEMS: TicketingSystem[] = []
const NO_OWNERS: string[] = []

// GitHub stays out until its organizations' settings load, so it never shows for a
// moment before they rule it out
export const useHasTicketingIntegration = () => {
  const { response: connected = NO_SYSTEMS } = useGetTicketingSystems()
  const { response: gitHubIssues } = useGetGitHubIssuesSettings(
    connected.includes("github")
  )
  const isGitHubIssuesAllowed = !!gitHubIssues?.isAllowed
  const ticketingSystems = useMemo(
    () => getAllowedTicketingSystems(connected, isGitHubIssuesAllowed),
    [connected, isGitHubIssuesAllowed]
  )

  return {
    ticketingSystems,
    issuesDisabledOwners: gitHubIssues?.disabledOwners ?? NO_OWNERS
  }
}
